module.exports = __webpack_public_path__ + "static/media/cocorobolixianban3.7d0cbb5e.png";